import { render, staticRenderFns } from "./AppSpinner.vue?vue&type=template&id=325ef187&"
import script from "./AppSpinner.vue?vue&type=script&lang=js&"
export * from "./AppSpinner.vue?vue&type=script&lang=js&"
import style0 from "./AppSpinner.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports